module.exports = __webpack_public_path__ + "static/media/enriched-air-diver-bg.dd3b8f64.jpg";